import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { filters } from "../../api/Dashboard"

/* Helpers */
import { utils } from "../../helpers"

/* Icons — the very same set the transactions filter draws */
import { CloseIcon, CheckIcon, SearchIcon, CalendarIcon, StudioIcon, FilterIcon, InfoIcon, OperatorIcon, PlayerIcon } from "../Transaction/TransactionIcons"

/* Timezone — the ranges are built in the SELECTED zone, not in the zone of the machine */
import { nowInTz } from "../../helpers/timezone"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* Moment */
import moment from "moment"

/* DatePicker Settings */
registerLocale("ru", ru)


/* THE INNER SEARCH APPEARS ONLY WHEN THE LIST OF STUDIOS IS LONG ENOUGH TO SCROLL */
const SEARCHABLE = 8

/* DATE FORMAT THE DASHBOARD SENDS */
const FORMAT = "YYYY-MM-DD HH:mm:ss"


/* Widget Dashboard Filter */
class Filter extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            selected: "today",
            start: null,
            end: null,
            operators: [],
            studios: [],
            testers: false,
            vips: true,
            allOperators: [],
            allStudios: [],
            search: "",
        }
    }

    /* Periods Of The Picker */
    getPeriods = () => [
        { key: "3hours", text: t("player.last3h") },
        { key: "6hours", text: t("player.last6h") },
        { key: "12hours", text: t("player.last12h") },
        { key: "today", text: t("player.today") },
        { key: "yesterday", text: t("player.yesterday") },
        { key: "7days", text: t("player.last7days") },
        { key: "14days", text: t("player.last14days") },
        { key: "30days", text: t("player.last30days") },
        { key: "month", text: t("player.thisMonth") },
        { key: "prevmonth", text: t("player.prevMonth") },
        { key: "all", text: t("player.allTime") },
    ]

    /* Open Action */
    open = ({ selected = "today", start = null, end = null, operators = [], studios = [], testers = false, vips = true }) => {

        this.setState({
            visible: true,
            selected,
            start: start ? moment(start, FORMAT).toDate() : null,
            end: end ? moment(end, FORMAT).toDate() : null,
            operators: [...operators],
            studios: [...studios],
            testers,
            vips,
            search: "",
        }, () => {
            this.load()
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* Load Action — the studios and the operators come strictly inside the scope of the token,
     * so no option of the filter can ever reach a foreign studio */
    load = () => {

        /* Check Loaded */
        if (this.state.allOperators.length > 0 || this.state.allStudios.length > 0) {
            return
        }

        /* Send to REST API */
        filters().then((response) => {
            if (response.status === 200) {
                this.setState({ allOperators: response.data.operators, allStudios: response.data.studios })
            }
        }).catch(() => {
            this.setState({ allOperators: [], allStudios: [] })
        })

    }

    /* Studios Of The Search */
    getStudios = () => {

        /* Fields */
        const { allStudios, search } = this.state
        const value = search.trim().toLowerCase()

        /* Check Search */
        if (value === "") {
            return allStudios
        }

        /* Send Result */
        return allStudios.filter((item) => {

            const name = String(utils.checkValue(item.name, "")).toLowerCase()
            const slug = String(utils.checkValue(item.slug, "")).toLowerCase()

            return name.includes(value) || slug.includes(value)
        })
    }

    /* Check Studio */
    checkStudio = (studio) => {
        return this.state.studios.findIndex((item) => parseInt(item.id) === parseInt(studio.id)) > -1
    }

    /* Toggle Studio */
    toggleStudio = (studio) => {

        /* Fields */
        const { studios } = this.state

        /* Get Index */
        const index = studios.findIndex((item) => parseInt(item.id) === parseInt(studio.id))

        /* Check Index */
        if (index > -1) {
            studios.splice(index, 1)
        }
        else {
            studios.push(studio)
        }

        this.setState({ studios })
    }

    /* Select Every Studio Of The Search — an empty selection already means every studio */
    selectStudios = () => {
        this.setState({ studios: [...this.getStudios()] })
    }

    /* Deselect Every Studio */
    deselectStudios = () => {
        this.setState({ studios: [] })
    }

    /* Check Operator */
    checkOperator = (operator) => {
        return this.state.operators.findIndex((item) => parseInt(item.id) === parseInt(operator.id)) > -1
    }

    /* Toggle Operator */
    toggleOperator = (operator) => {

        /* Fields */
        const { operators } = this.state

        /* Get Index */
        const index = operators.findIndex((item) => parseInt(item.id) === parseInt(operator.id))

        /* Check Index */
        if (index > -1) {
            operators.splice(index, 1)
        }
        else {
            operators.push(operator)
        }

        this.setState({ operators })
    }

    /* Select Every Operator */
    selectOperators = () => {
        this.setState({ operators: [...this.state.allOperators] })
    }

    /* Deselect Every Operator */
    deselectOperators = () => {
        this.setState({ operators: [] })
    }

    /* Select Period */
    select = (selected) => {

        /* All Period — no border goes to the request */
        if (selected === "all") {
            this.setState({ start: null, end: null, selected })
            return
        }

        /* Hours */
        const hours = { "3hours": 3, "6hours": 6, "12hours": 12 }

        if (hours[selected]) {
            this.setState({ start: nowInTz().subtract(hours[selected], "hours").toDate(), end: nowInTz().toDate(), selected })
            return
        }

        /* Today */
        if (selected === "today") {
            this.setState({ start: nowInTz().startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* Yesterday */
        if (selected === "yesterday") {
            this.setState({
                start: nowInTz().subtract(1, "day").startOf("day").toDate(),
                end: nowInTz().subtract(1, "day").endOf("day").toDate(),
                selected,
            })
            return
        }

        /* Days */
        const days = { "7days": 6, "14days": 13, "30days": 29 }

        if (days[selected] !== undefined) {
            this.setState({ start: nowInTz().subtract(days[selected], "days").startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* This Month */
        if (selected === "month") {
            this.setState({ start: nowInTz().startOf("month").toDate(), end: nowInTz().endOf("month").toDate(), selected })
            return
        }

        /* Previous Month */
        if (selected === "prevmonth") {
            this.setState({
                start: nowInTz().subtract(1, "month").startOf("month").toDate(),
                end: nowInTz().subtract(1, "month").endOf("month").toDate(),
                selected,
            })
        }

    }

    /* Reset Action */
    reset = () => {
        this.setState({
            selected: "today",
            start: nowInTz().startOf("day").toDate(),
            end: nowInTz().endOf("day").toDate(),
            operators: [],
            studios: [],
            testers: false,
            vips: true,
            search: "",
        })
    }

    /* Apply Action */
    apply = () => {

        /* Fields */
        const { selected, start, end, operators, studios, testers, vips } = this.state
        const { apply } = this.props

        /* Check Dates */
        if (selected !== "all" && (!start || !end)) {
            Swal.fire(utils.notification(t("filter.selectDates"), "error", 2000))
            return
        }

        /* Set Apply — the whole period keeps no borders at all */
        apply({
            selected,
            start: selected === "all" ? null : moment(start).format(FORMAT),
            end: selected === "all" ? null : moment(end).format(FORMAT),
            operators,
            studios,
            testers,
            vips,
        })

        /* Close Modal */
        this.close()
    }

    /* Draw Period */
    _period = () => {

        /* Fields */
        const { selected, start, end } = this.state

        return (
            <div className="gtx--section">

                <div className="gtx--section-head">
                    <div className="gtx--section-title">
                        <CalendarIcon />
                        {t("gtx.period")}
                    </div>
                </div>

                <div className="gtx--chips">
                    {this.getPeriods().map((item, index) =>
                        <div
                            onClick={() => this.select(item.key)}
                            className={`gtx--chip ${selected === item.key ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.text}
                        </div>
                    )}
                </div>

                <div className="gtx--range">

                    <DatePicker
                        selected={start}
                        onChange={(date) => this.setState({ start: date, selected: "period" })}
                        selectsStart
                        startDate={start}
                        endDate={end}
                        maxDate={end}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("gtx.dateFrom")}
                    />

                    <DatePicker
                        selected={end}
                        onChange={(date) => this.setState({ end: date, selected: "period" })}
                        selectsEnd
                        startDate={start}
                        endDate={end}
                        minDate={start}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("gtx.dateTo")}
                    />

                </div>

            </div>
        )
    }

    /* Draw Players — the test and the VIP accounts are inside the numbers until they are dropped */
    _players = () => {

        /* Fields */
        const { testers, vips } = this.state

        return (
            <div className="gtx--section">

                <div className="gtx--section-head">
                    <div className="gtx--section-title">
                        <PlayerIcon />
                        {t("gtx.players")}
                    </div>
                </div>

                <div className="gtx--chips">

                    <div onClick={() => this.setState({ testers: !testers })} className={`gtx--check ${testers ? "active" : ""}`}>
                        <div className="gtx--check-box">{testers && <CheckIcon size={11} />}</div>
                        <span>{t("gtx.includeTesters")}</span>
                    </div>

                    <div onClick={() => this.setState({ vips: !vips })} className={`gtx--check ${vips ? "active" : ""}`}>
                        <div className="gtx--check-box">{vips && <CheckIcon size={11} />}</div>
                        <span>{t("gtx.includeVips")}</span>
                    </div>

                </div>

            </div>
        )
    }

    /* Draw Operators — a scope with a single operator has nothing to choose from */
    _operators = () => {

        /* Fields */
        const { allOperators, operators } = this.state

        /* Check Operators */
        if (allOperators.length < 2) {
            return null
        }

        return (
            <div className="gtx--section">

                <div className="gtx--section-head">

                    <div className="gtx--section-title">
                        <OperatorIcon />
                        {t("gtx.operators")}
                        <span className={`gtx--counter ${operators.length === 0 ? "empty" : ""}`}>{operators.length}</span>
                    </div>

                    <div className="gtx--section-actions">
                        <span onClick={() => this.selectOperators()}>{t("filter.selectAll")}</span>
                        <span onClick={() => this.deselectOperators()}>{t("filter.deselectAll")}</span>
                    </div>

                </div>

                <div className="gtx--chips">
                    {allOperators.map((item, index) =>
                        <div
                            onClick={() => this.toggleOperator(item)}
                            className={`gtx--chip ${this.checkOperator(item) ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.name}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* Draw Studios — a studio brings every game of its own */
    _studios = () => {

        /* Fields */
        const { allStudios, studios, search } = this.state
        const list = this.getStudios()

        return (
            <div className="gtx--section">

                <div className="gtx--section-head">

                    <div className="gtx--section-title">
                        <StudioIcon />
                        {t("filter.studios")}
                        <span className={`gtx--counter ${studios.length === 0 ? "empty" : ""}`}>{studios.length}</span>
                    </div>

                    <div className="gtx--section-actions">
                        <span onClick={() => this.selectStudios()}>{t("filter.selectAll")}</span>
                        <span onClick={() => this.deselectStudios()}>{t("filter.deselectAll")}</span>
                    </div>

                </div>

                {allStudios.length > SEARCHABLE &&
                    <div className="gtx--inner-search">
                        <SearchIcon size={14} />
                        <input value={search} onChange={(event) => this.setState({ search: event.target.value })} placeholder={t("dsh.searchByStudio")} />
                        {search !== "" &&
                            <div onClick={() => this.setState({ search: "" })} className="gtx--inner-search-clear">
                                <CloseIcon size={11} />
                            </div>
                        }
                    </div>
                }

                {list.length === 0 &&
                    <div className="gtx--chips-empty">{search !== "" ? t("gtx.nothingFound") : t("dsh.studiosEmpty")}</div>
                }

                <div className="gtx--tables">
                    {list.map((item, index) =>
                        <div
                            onClick={() => this.toggleStudio(item)}
                            className={`gtx--table-chip ${this.checkStudio(item) ? "active" : ""}`}
                            key={`${index}`}
                        >

                            <div className="gtx--table-box">{this.checkStudio(item) && <CheckIcon size={11} />}</div>

                            <div className="gtx--table-text">
                                <div className="gtx--table-name">{utils.checkValue(item.name, item.slug)}</div>
                                <div className="gtx--table-note">{t("gtx.games")}: {utils.checkValue(item.games, 0)}</div>
                            </div>

                        </div>
                    )}
                </div>

                <div className="gtx--hint">
                    <InfoIcon />
                    <span>{t("dsh.filterHint")}</span>
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="gtx--modal"
                overlayClassName="gtx--overlay"
                closeTimeoutMS={200}
            >

                <div className="gtx--modal-header">

                    <div className="gtx--modal-icon">
                        <FilterIcon size={18} />
                    </div>

                    <div className="gtx--modal-head-text">
                        <h2>{t("dsh.filterTitle")}</h2>
                        <p>{t("dsh.filterSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="gtx--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="gtx--modal-body">

                    {/* Draw Period */}
                    {this._period()}

                    {/* Draw Players */}
                    {this._players()}

                    {/* Draw Studios */}
                    {this._studios()}

                    {/* Draw Operators */}
                    {this._operators()}

                </div>

                <div className="gtx--modal-footer space">

                    <div onClick={() => this.reset()} className="gtx--button ghost">{t("gtx.reset")}</div>

                    <div className="gtx--modal-footer-right">
                        <div onClick={() => this.close()} className="gtx--button ghost">{t("filter.cancel")}</div>
                        <div onClick={() => this.apply()} className="gtx--button primary">{t("filter.apply")}</div>
                    </div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Filter)
